import { useTheme } from 'styled-components';

import ArrowLine from '~components/Icon/ArrowLine';
import BuildingIcon from '~components/Icon/BuildingIcon';
import ClockIcon from '~components/Icon/ClockIcon';
import CompanyIndustryIcon from '~components/Icon/CompanyIndustryIcon';
import LocationIcon from '~components/Icon/LocationIcon';
import Text from '~components/Text';
import { CompanyInfoResponse } from '~hooks/query/company/useCompanyInfo';
import useGetIndustryByCode from '~hooks/useGetIndustryByCode';
import useMedia from '~hooks/useMedia';
import { COMPANY_TYPE, CompanyStates } from '~types/company';
import { getShortenedAddress } from '~utils/locationFormat';

import { getCompanyYear } from './hooks';
import { S } from './style';

interface Props {
  companyInfo?: CompanyInfoResponse;
  companyStates?: CompanyStates;
}
function CompanyDescription({ companyInfo, companyStates }: Props) {
  const theme = useTheme();
  const { isDesktop } = useMedia();
  const { getIndustryByCode } = useGetIndustryByCode();

  return (
    <S.Wrapper>
      <S.CompanyName typography={`bold150_H${isDesktop ? '4' : '5'}`}>
        {companyInfo?.name}
      </S.CompanyName>
      <S.CompanyInfoItem>
        <S.TextItem>
          <Text typography={`midium150_${isDesktop ? 'C1' : 'B3'}`}>
            <BuildingIcon width={12} height={11} fill={theme.colors.gray700} />
            {companyInfo && (COMPANY_TYPE[companyInfo.category] || companyInfo.category)}
          </Text>
          <img src={'/images/ellipse.svg'} alt='ellipse' />
          <Text typography={`midium150_${isDesktop ? 'C1' : 'B3'}`}>
            <CompanyIndustryIcon width={12} height={11} fill={theme.colors.gray700} />
            {companyInfo && getIndustryByCode(companyInfo.industryCode)?.name}
          </Text>
          {isDesktop && <img src={'/images/ellipse.svg'} alt='ellipse' />}
        </S.TextItem>
        <S.TextItem>
          <Text typography={`midium150_${isDesktop ? 'C1' : 'B3'}`}>
            <ClockIcon width={12} height={13} fill={theme.colors.gray700} />
            {companyInfo && (companyInfo.age || companyInfo.foundedYear) ? (
              <>
                {`${
                  Number(companyInfo.age.toFixed()) > 0
                    ? `${companyInfo.age.toFixed()}년`
                    : '1년 미만'
                } (${getCompanyYear(companyInfo.foundedYear, companyStates)})`}
              </>
            ) : (
              '정보없음'
            )}
          </Text>
          <img src={'/images/ellipse.svg'} alt='ellipse' />
          <Text typography={`midium150_${isDesktop ? 'C1' : 'B3'}`}>
            <LocationIcon width={14} height={15} fill={theme.colors.gray700} />
            {companyInfo && getShortenedAddress(companyInfo.locationCode, companyInfo.location)}
          </Text>
        </S.TextItem>
      </S.CompanyInfoItem>
      {companyInfo?.niceId && (
        <div>
          <a
            data-attribute-id='company__nice__seeMore'
            data-company-id={companyInfo.id}
            data-company-name={companyInfo.name}
            data-company-type={companyInfo.category}
            href={`https://www.nicebizinfo.com/ep/EP0100M002GE.nice?kiscode=${companyInfo.niceId}&siteid=kreditjob`}
            target='_blank'
            rel='noopener noreferrer'>
            <Text typography={`midium150_${isDesktop ? 'C1' : 'B3'}`}>
              NICE기업 정보 더 보기
              <ArrowLine
                width={5}
                height={7}
                color={theme.colors.greymint300}
                style={{ marginLeft: '2px' }}
              />
            </Text>
          </a>
        </div>
      )}
    </S.Wrapper>
  );
}

export default CompanyDescription;
